// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-wrapper[data-v-122ba2be] {\n  max-height: calc(100vh - 340px) !important;\n  min-height: 50px;\n}\n.table[data-v-122ba2be] {\n  margin-bottom: 0;\n}\n[data-v-122ba2be] .empty-list {\n  margin-bottom: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
